<template>
  <div class="table-container">
    <b-overlay class="p-0" center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="showForm">
          <div class="flex-container" v-if="reportOptions.length">
            <div
              class="flex-item"
              v-for="(report, index) in reportOptions"
              :key="index"
              tabindex="1"
              @click="onClickReport(report.value)"
            >
              <div class="flex-item-inner-container">
                <span class="info">
                  <small class="code">{{ report.value }}</small>
                  <b-button
                    squared
                    type="submit"
                    variant="primary"
                    class="btn-create"
                    size="lg"
                    :disabled="report.disabled"
                    title=" Crea Report"
                  >
                    <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  </b-button>
                </span>
                <span class="title">{{ report.text.toLowerCase() }}</span>
              </div>
            </div>
          </div>
          <div v-else>Nessun report disponibile</div>
          <submit-report-modal
            :code="reportCode"
            :reportId="reportId"
            :beFormCreate="beCreateForm"
            :beRulesCreate="beRulesCreate"
            :allowedFormatOptions="allowed"
            @save-report="saveReport"
          >
          </submit-report-modal>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import submitReportModal from "@/components/modals/submitReportModal";
import FormMixin from "@/mixins/FormMixin";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import { canVerb } from "@/utils/permissions";
import { mapGetters } from "vuex";

export default {
  mixins: [FormMixin, StorageGetterMixin],
  props: {
    reportsAvailable: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      repository: "report",
      resource: "reports",
      isLoading: false,
      showForm: true,
      report: null,
      reports: [],
      reportOptions: [],
      // reportsAvailable: ["AGGRECLI", "MONUPROD"],
      allowed: [],
      reportCode: null,
      reportId: null,
      beRulesCreate: null,
      beCreateForm: null,
    };
  },
  components: { submitReportModal },
  methods: {
    canVerb,
    getToastLabel(code) {
      let ret = this.getReport()(code);
      return `${ret.code} - ${ret.title}`;
    },
    getReports() {
      this.reports = this.$store.state.auth.reports.filter((e) =>
        this.reportsAvailable.includes(e.code),
      );
      this.reportOptions = this.reports.map((e) => {
        return {
          value: e.code,
          text: e.title,
          disabled: false,
        };
      });
    },
    actionButton(action = false) {
      this.reportOptions.forEach((report) => {
        report.disabled = action;
      });
    },
    openReportModal(code) {
      this.actionButton(true);
      this.fetchEditForm(this.repository, code)
        .then(() => {
          this.$set(this, "beCreateForm", this.beForm["report"]);
          this.$set(this, "beRulesCreate", this.beRules["report"]);
          this.$set(
            this,
            "allowed",
            this.beForm["report"].format.options.filter((format) =>
              this.allowed.includes(format.text),
            ),
          );
          this.actionButton(false);
          console.log(code);
          this.$bvModal.show(code);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: errMsg });
        });
    },
    checkReportPermission(users) {
      const loggedUser = this.$store.state.auth.user;
      const found = users.find((user) => user.id === loggedUser.id);
      if (found) {
        if (found.pivot.allowed.length) {
          this.allowed = found.pivot.allowed;
          return true;
        }
      }
      return false;
    },
    onClickReport(value) {
      const report = this.reports.find((report) => report.code === value);
      if (this.checkReportPermission(report.users)) {
        this.reportCode = value;
        this.reportId = report.id;
        this.openReportModal(value);
      } else {
        this.$showSnackbar({
          preset: "info",
          text: `Non puoi eseguire il report ${value}`,
        });
      }
    },
    saveReport(code, form) {
      // this.update("report", code, form)
      const Repo = RepositoryFactory.get(this.repository);
      Repo.report(code, form)
        .then((response) => {
          console.log("form", form);
          console.log("code", code);
          this.resetForm();
          this.$showSnackbar({
            preset: "info",
            text: `Richiesta accettata: report in elaborazione`,
          });
          this.$bvModal.hide(code);
          const reportObj = {
            id: response?.data?.data?.payload?.job?.args.generated_id ?? false,
            code: code,
            format: form?.format,
            label: this.getToastLabel(code),
          };
          this.$root.$emit("toastReport", reportObj);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$bvModal.hide(code);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    ...mapGetters("auth", {
      getReport: "report",
    }),
  },
  created() {
    /* */
    const path = "auth/";
    const resources = [];
    if (this.canVerb("reports", "index") && !this.hasLoadedResource("reports"))
      resources.push(
        this.$store
          .dispatch(`${path}reports`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          this.getReports();
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.getReports();
      this.isLoading = false;
    }
    /* */
  },
  watch: {
    reportsAvailable: function () {
      this.getReports();
    },
  },
};
</script>

<style scoped>
.flex-container {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  column-gap: 20px;
  row-gap: 20px;
  grid-auto-flow: row;
  padding: 0;
  width: 100%;
}

.flex-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 12px;
  /* outline: 1px solid #ccc !important; */
  overflow: hidden;
  padding: 12px;
  gap: 8px;
  cursor: pointer;
  transition: 0.2s all linear 0.1s;
  /* */
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: var(--radius-lg);
  background: rgba(0, 0, 0, 0.05);
  padding: 6px;
  transition: background 0.2s linear, border-color 0.2s linear;
  /* */
}

.flex-item-inner-container {
  border-radius: 0.5rem;
  border: 1px solid #fff;
  background-color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px;
  gap: 8px;
}

.flex-item:hover {
  background-color: var(--gray-50);
  background-color: rgba(0, 159, 227, 0.3);
  /* outline-color: #007bff !important; */
}

.flex-item * {
  pointer-events: none;
  touch-action: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.flex-item .info {
  position: relative;
}

.flex-item .code {
  font-weight: bold;
  padding-left: 28px;
  color: #0061c9;
}

.flex-item .title {
  line-height: 1em;
}

.flex-item .title::first-letter {
  text-transform: uppercase;
}

.flex-item .btn-create {
  position: absolute;
  top: -2px;
  left: 0px;
  border-radius: 50% !important;
  width: 21px;
  height: 21px;
  padding: 0;
}

.flex-item .btn-create svg {
  font-size: 121%;
}
</style>
